/**
 * Real Wales — Product Page Enhancements v2
 * File: assets/rw-product.js
 * Load via: <script src="{{ 'rw-product.js' | asset_url }}" defer></script>
 * Add that line to theme.liquid just before </body>
 */

(function () {
  'use strict';

  if (!document.querySelector('.product-form')) return;


  /* ── TRUST STRIP ───────────────────────────────────── */

  function buildTrustStrip() {
    const strip = document.createElement('div');
    strip.className = 'rw-trust-strip';
    strip.setAttribute('role', 'list');
    strip.innerHTML = `
      <div class="rw-trust-strip__item" role="listitem">
        <svg class="rw-trust-strip__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M10 2L3 5v5c0 4.4 3 8.3 7 9.3 4-1 7-4.9 7-9.3V5l-7-3z"
            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
          <path d="M7 10l2 2 4-4"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Secure checkout</span>
      </div>
      <div class="rw-trust-strip__item" role="listitem">
        <svg class="rw-trust-strip__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <rect x="1" y="6" width="14" height="9" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
          <path d="M15 9l3 2v4h-3V9z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
          <circle cx="5" cy="17" r="1.5" stroke="currentColor" stroke-width="1.5"/>
          <circle cx="13" cy="17" r="1.5" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        <span>Free UK delivery</span>
      </div>
      <div class="rw-trust-strip__item" role="listitem">
        <svg class="rw-trust-strip__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <rect x="3" y="2" width="14" height="18" rx="1.5" stroke="currentColor" stroke-width="1.5"/>
          <path d="M7 7h6M7 10h6M7 13h4"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span>Printed to order</span>
      </div>
      <div class="rw-trust-strip__item" role="listitem">
        <svg class="rw-trust-strip__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <circle cx="10" cy="9" r="6" stroke="currentColor" stroke-width="1.5"/>
          <path d="M10 6v3.5l2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M5 16l-1.5 2.5M15 16l1.5 2.5"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span>Dispatched in 3–5 days</span>
      </div>
    `;
    return strip;
  }


  /* ── PAPER GUIDE MODAL ─────────────────────────────── */

  function buildPaperModal() {
    const el = document.createElement('div');
    el.className = 'rw-modal-backdrop';
    el.id = 'rw-paper-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'rw-paper-title');
    el.innerHTML = `
      <div class="rw-modal">
        <button class="rw-modal__close" data-close-modal aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M5 5l10 10M15 5L5 15"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>

        <h2 class="rw-modal__title" id="rw-paper-title">Which paper should I choose?</h2>

        <div class="rw-paper-option">
          <p class="rw-paper-option__name">Standard 250gsm</p>
          <p class="rw-paper-option__spec">Premium photo paper · Satin finish</p>
          <p class="rw-paper-option__desc">
            A thick, high-quality satin paper that makes colours vivid and sharp.
            A great all-rounder — particularly well-suited to the neo-vintage prints
            where bold, saturated colours are the point. Also the better choice as a gift,
            or if you're building a gallery wall and want a consistent clean finish.
          </p>
          <hr class="rw-modal__rule">
          <div class="rw-paper-compare">
            <span class="rw-paper-compare__label">Surface</span>
            <span class="rw-paper-compare__val">Satin, smooth</span>
            <span class="rw-paper-compare__label">Weight</span>
            <span class="rw-paper-compare__val">250gsm</span>
            <span class="rw-paper-compare__label">Best for</span>
            <span class="rw-paper-compare__val">Neo-vintage prints, gifts, gallery walls</span>
          </div>
        </div>

        <div class="rw-paper-option rw-paper-option--recommended">
          <span class="rw-paper-option__badge">Fine art choice</span>
          <p class="rw-paper-option__name">Hahnemühle German Etching 310gsm</p>
          <p class="rw-paper-option__spec">Museum-grade fine art paper · Textured matte</p>
          <p class="rw-paper-option__desc">
            Hahnemühle German Etching is used by galleries and professional photographers
            worldwide. Its distinctive warm-white textured surface gives prints real tactile
            depth — it feels like holding a piece of art, not a photograph. The matte finish
            eliminates glare entirely. Particularly stunning for the fine art photography
            prints where tonal range, shadow detail and atmosphere matter most.
          </p>
          <hr class="rw-modal__rule">
          <div class="rw-paper-compare">
            <span class="rw-paper-compare__label">Surface</span>
            <span class="rw-paper-compare__val">Textured matte</span>
            <span class="rw-paper-compare__label">Weight</span>
            <span class="rw-paper-compare__val">310gsm</span>
            <span class="rw-paper-compare__label">Best for</span>
            <span class="rw-paper-compare__val">Photography prints, collectors, statement pieces</span>
          </div>
        </div>

        <p style="font-size:0.75rem;color:#6B6860;margin-top:0.5rem;line-height:1.6;">
          Both papers use professional archival pigment inks rated for 75+ years before fading,
          when kept out of direct sunlight. Neither choice is wrong — it comes down to whether
          you prefer vivid and smooth, or textured and matte.
        </p>
      </div>
    `;
    return el;
  }


  /* ── SIZE GUIDE MODAL ──────────────────────────────── */

  function buildSizeModal() {
    const el = document.createElement('div');
    el.className = 'rw-modal-backdrop';
    el.id = 'rw-size-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'rw-size-title');

    const sizes = [
      { name: 'A1', w: 594, h: 841, note: 'Statement piece' },
      { name: 'A2', w: 420, h: 594, note: 'Large feature' },
      { name: 'A3', w: 297, h: 420, note: 'Most popular' },
      { name: 'A4', w: 210, h: 297, note: 'Gallery wall' },
    ];

    const scale = 80 / 841;

    const sizeItemsHTML = sizes.map(s => {
      const pw = Math.round(s.w * scale);
      const ph = Math.round(s.h * scale);
      return `
        <div class="rw-size-item">
          <div class="rw-size-item__rect" style="width:${pw}px;height:${ph}px;"></div>
          <div class="rw-size-item__name">${s.name}</div>
          <div class="rw-size-item__dims">
            ${s.w}×${s.h}mm<br>
            ${s.name === 'A1' ? '23.4×33.1"' : s.name === 'A2' ? '16.5×23.4"' : s.name === 'A3' ? '11.7×16.5"' : '8.3×11.7"'}
          </div>
        </div>
      `;
    }).join('');

    const personPx = 60;
    const cmPerPx  = 170 / personPx;
    const scaleBar = sizes.map(s => {
      const ph = Math.round((s.h / 10) / cmPerPx);
      const pw = Math.round((s.w / 10) / cmPerPx);
      return `<div class="rw-scale-print" style="height:${ph}px;width:${pw}px;"><span>${s.name}</span></div>`;
    }).join('');

    el.innerHTML = `
      <div class="rw-modal">
        <button class="rw-modal__close" data-close-modal aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M5 5l10 10M15 5L5 15"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>

        <h2 class="rw-modal__title" id="rw-size-title">Print size guide</h2>

        <div class="rw-size-visual">${sizeItemsHTML}</div>
        <p style="font-size:0.65rem;color:#6B6860;text-align:center;margin:4px 0 1rem;">
          Shown to scale relative to each other
        </p>

        <div class="rw-scale-bar">
          <div class="rw-scale-figure">
            <div class="rw-scale-person-head"></div>
            <div class="rw-scale-person-body" style="height:${personPx}px;"></div>
            <div class="rw-scale-label">170cm</div>
          </div>
          <div>
            <div class="rw-scale-prints">${scaleBar}</div>
            <div class="rw-scale-label" style="margin-top:6px;">Approximate height on a wall</div>
          </div>
        </div>

        <hr class="rw-modal__rule">

        <div class="rw-size-context">
          <p><strong>A4</strong> — Perfect for a gallery wall cluster of 3–6 prints, a desk, or a shelf.</p>
          <p><strong>A3</strong> — The most versatile size. Stands alone above a fireplace, sideboard or in a hallway.</p>
          <p><strong>A2</strong> — A strong feature print for living rooms and bedrooms. Holds its own on larger walls.</p>
          <p><strong>A1</strong> — A real statement piece. Best in large, high-ceilinged rooms with room to breathe.</p>
        </div>

        <p class="rw-size-note">
          All prints include an integrated white border — approximately 1–2cm on each side —
          giving a gallery mount effect without a separate mat board. Factor this in when
          choosing a frame.
        </p>
      </div>
    `;
    return el;
  }


  /* ── MODAL MANAGEMENT ──────────────────────────────── */

  function openModal(id) {
    const m = document.getElementById(id);
    if (!m) return;
    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const closeBtn = m.querySelector('[data-close-modal]');
    if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
  }

  function closeAll() {
    document.querySelectorAll('.rw-modal-backdrop.is-open').forEach(m => {
      m.classList.remove('is-open');
    });
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('rw-modal-backdrop')) closeAll();
    if (e.target.closest('[data-close-modal]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });


  /* ── PRICE ON BUTTON ───────────────────────────────── */
  /*
   * KEY FIX: We update only the <span> inside the button,
   * NOT btn.textContent — which would wipe out Dawn's
   * .loading__spinner and .sold-out-message elements.
   */

  function setButtonPrice() {
    const btn = document.querySelector('.product-form__submit');
    if (!btn || btn.disabled) return;

    // Dawn puts the label text inside a <span> inside the button
    let labelSpan = btn.querySelector('span:not(.sold-out-message):not(.loading__spinner)');

    // If no span exists yet, create one and prepend it
    if (!labelSpan) {
      labelSpan = document.createElement('span');
      btn.prepend(labelSpan);
    }

    const priceEl = document.querySelector(
      '.price__regular .price-item--regular, ' +
      '.price .price-item--regular'
    );
    if (!priceEl) return;

    const priceText = priceEl.textContent.trim();
    if (priceText) {
      labelSpan.textContent = `Add to cart — ${priceText}`;
    }
  }

  document.addEventListener('variant:changed', function () {
    setTimeout(setButtonPrice, 30);
  });

  document.addEventListener('change', function (e) {
    if (e.target.type === 'radio') {
      setTimeout(setButtonPrice, 80);
    }
  });


  /* ── DESCRIPTION CLEANUP ───────────────────────────── */

  function cleanDescription() {
    const desc = document.querySelector('.product__description');
    if (!desc) return;

    const emojiRe = /[🚚✔️🎨⭐💫🌟✨🔥💚🏴󠁧󠁢󠁷󠁬󠁳󠁿]/gu;
    desc.querySelectorAll('p, li, strong, b').forEach(el => {
      el.childNodes.forEach(node => {
        if (node.nodeType === 3) {
          const cleaned = node.textContent.replace(emojiRe, '').replace(/^\s+/, '');
          if (cleaned !== node.textContent) node.textContent = cleaned;
        }
      });
    });
  }


  /* ── INJECT HELP LINKS ─────────────────────────────── */

  function injectHelpLinks() {
    const allInputs = document.querySelectorAll('.product-form__input');
    let targetInput = null;

    allInputs.forEach(function (input) {
      const labels = input.querySelectorAll('label, legend, .form__label');
      labels.forEach(function (lbl) {
        if (/gsm|size|paper|quality/i.test(lbl.textContent)) {
          targetInput = input;
        }
      });
    });

    if (!targetInput) {
      allInputs.forEach(function (input) {
        if (!targetInput && input.querySelector('input[type="radio"]')) {
          targetInput = input;
        }
      });
    }

    if (!targetInput) return;
    if (targetInput.querySelector('.rw-variant-links')) return;

    const linkRow = document.createElement('div');
    linkRow.className = 'rw-variant-links';

    const sizeBtn = document.createElement('button');
    sizeBtn.type = 'button';
    sizeBtn.className = 'rw-size-guide-trigger';
    sizeBtn.setAttribute('aria-haspopup', 'dialog');
    sizeBtn.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/>
        <path d="M10 9v5M10 7v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      Size guide
    `;
    sizeBtn.addEventListener('click', () => openModal('rw-size-modal'));

    const paperBtn = document.createElement('button');
    paperBtn.type = 'button';
    paperBtn.className = 'rw-paper-guide-trigger';
    paperBtn.setAttribute('aria-haspopup', 'dialog');
    paperBtn.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/>
        <path d="M10 9v5M10 7v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      Which paper should I choose?
    `;
    paperBtn.addEventListener('click', () => openModal('rw-paper-modal'));

    linkRow.appendChild(sizeBtn);
    linkRow.appendChild(paperBtn);
    targetInput.appendChild(linkRow);
  }


  /* ── INIT ──────────────────────────────────────────── */

  function init() {
    const submitBtn = document.querySelector('.product-form__submit');
    if (!submitBtn) return;

    const trustStrip = buildTrustStrip();
    submitBtn.parentNode.insertBefore(trustStrip, submitBtn);

    document.body.appendChild(buildPaperModal());
    document.body.appendChild(buildSizeModal());

    injectHelpLinks();
    setButtonPrice();
    cleanDescription();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();